// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._38HyqhCoyRJAin {\n  font-size: 14px;\n  line-height: 20px;\n}\n._2u7h3auYUxVuOk {\n  text-decoration: underline;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messaging": "_38HyqhCoyRJAin",
	"ctaLink": "_2u7h3auYUxVuOk"
};
export default ___CSS_LOADER_EXPORT___;
